module.exports = __webpack_public_path__ + "media/images/flags/64/Mongolia-52214e5a64271573c5725cb9eb82ac4a.png";